import { checkIsStaging } from "./checkIsStaging";
export const createCustomUrl = (route) =>
  checkIsStaging() ? `https://web.digitaldukaan.app${route}` : `https://web.dotpe.in${route}`;
